/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{top:6rem!important;left:0}[_nghost-%COMP%]   .toast[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto;text-shadow:0 1px 3px rgba(115,8,33,.2);background-image:linear-gradient(0deg,#b50f36 0,#d3113f 100%)}[_nghost-%COMP%]   .toast.success[_ngcontent-%COMP%]{text-shadow:0 1px 2px rgba(70,104,6,.5);background-image:linear-gradient(0deg,#6ea807 0,#94cd13 100%)}"];
export { styles as styles };
